import React from "react";
import { TypingIndicatorContainer, TypingDot } from "./styles";

const TypingIndicator = () => {
	return (
		<TypingIndicatorContainer>
			<TypingDot />
			<TypingDot />
			<TypingDot />
		</TypingIndicatorContainer>
	);
};

export default TypingIndicator;
